import {
  Avatar,
  Box,
  Flex,
  Heading,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { Link, useLocation } from "react-router-dom";
import { HiOutlineLogout } from "react-icons/hi";
import { IoIosArrowDown } from "react-icons/io";
import { CONTAINER_W } from "../constants";

import MakerKidsLogo from "../mk_logo_new.png";
import { User } from "../models";
import { useMemo } from "react";

type PropTypes = {
  user?: User;
};

const TopMenu = ({ user }: PropTypes) => {
  const { pathname } = useLocation();
  const isBookPage = useMemo(() => pathname.startsWith("/book"), [pathname]);

  return (
    <Box
      {...(isBookPage
        ? {
            bg: "white",
            height: "74px",
            display: "flex",
            alignItems: "center",
            borderBottom: "1px solid #E5E5E5",
            boxShadow: "0px 2px 15px rgba(0, 0, 0, 0.03)",
          }
        : {})}
    >
      <Flex
        px={4}
        py={2}
        margin="0 auto"
        mb={isBookPage ? 0 : 4}
        w={CONTAINER_W}
        alignItems="center"
        justifyContent="space-between"
        direction="row"
      >
        <Flex direction="row" mx={isBookPage ? "auto" : 0}>
          <Link to="/">
            <Heading
              cursor="pointer"
              size="md"
              position="relative"
              color="black"
            >
              <img
                src={MakerKidsLogo}
                alt="MakerKids Logo"
                style={{ height: "40px", marginLeft: "-4px" }}
              />
            </Heading>
          </Link>
        </Flex>
        {user && (
          <Flex p={2} pl={3} pr={3} background="white" alignItems="center">
            <Avatar
              size="sm"
              name={`${user.givenNames} ${user.familyName}`}
              src={user.image || undefined}
            />
            <Box mx="2">
              <Text fontSize="sm" fontWeight="bold">
                {user.givenNames}
              </Text>
              <Text fontSize="xs">{user.email}</Text>
            </Box>
            <Menu placement="bottom-end">
              <MenuButton
                as={IconButton}
                aria-label="Options"
                icon={<IoIosArrowDown />}
                variant="outline"
                verticalAlign="-10px"
                size="sm"
                isRound
              />
              <MenuList>
                <MenuItem
                  icon={<HiOutlineLogout />}
                  onClick={() => alert("sign out")}
                >
                  Logout
                </MenuItem>
              </MenuList>
            </Menu>
          </Flex>
        )}
      </Flex>
    </Box>
  );
};

export default TopMenu;
